import React, { PureComponent } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import Transition from './Transition';

const styles = () => ({
	dialogPaper: {
		overflow: 'scroll',
		maxWidth: '100%',
		width: 800,
		height: '95%',
		maxHeight: 'calc(100% - 20px)',
		margin: 10,
	},
	pageImage: {
		width: '100%',
		//height : '100%',
		border: '1px solid #888',
		marginLeft: 10,
	},
});

class ResourcePopup extends PureComponent {
	/*
	constructor (props) {
		super(props);
	}
	*/

	handleClose = () => {
		this.props.onClose();
	};

	render() {
		const { classes, resourceIds, resourceMap, fullScreen } = this.props;

		if (_.isEmpty(resourceIds)) {
			return null;
		}

		const resources = [];
		resourceIds.forEach((resourceId) => {
			if (!resourceMap[resourceId]) {
				resources.push({ error: `Missing resourceId ${resourceId}. Maybe it was deleted?` });
			} else {
				resources.push(resourceMap[resourceId]);
			}
		});

		return (
			<div>
				<Dialog
					open={this.props.open}
					TransitionComponent={Transition}
					onClose={this.handleClose}
					fullScreen={fullScreen}
					maxWidth="lg"
					classes={{
						paper: classes.dialogPaper,
					}}
				>
					<DialogTitle>
						<div style={{ alignItems: 'center', display: 'flex', justifyContent: 'space-between' }}>
							<Button onClick={this.handleClose}>Close</Button>
						</div>
					</DialogTitle>
					<DialogContent style={{ height: '100%', paddingLeft: 40, paddingRight: 40 }}>
						{resources.map((resource, i) => {
							const { url, contentType, error } = resource;
							if (error) {
								return <div key={i}>ERROR: {error}</div>;
							} else if (contentType === 'application/pdf') {
								return (
									<object
										key={i}
										data={resource.url}
										style={{ height: '100%', width: '100%', maxWidth: '100%' }}
										type="application/pdf"
									>
										<a href={url}>attachment.pdf</a>
									</object>
								);
							} else {
								return (
									<div key={i}>
										<img alt={`page ${i}`} className={classes.pageImage} src={url} />
									</div>
								);
							}
						})}
					</DialogContent>
				</Dialog>
			</div>
		);
	}
}

ResourcePopup.propTypes = {
	resourceIds: PropTypes.array,
	resourceMap: PropTypes.object,
	open: PropTypes.bool,
	onClose: PropTypes.func,
	fullScreen: PropTypes.bool.isRequired,
	classes: PropTypes.object,
};

export default _.flow([withStyles(styles), withMobileDialog()])(ResourcePopup);
